import { Component, OnInit } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { NavigationService } from '@app/services/navigation/navigation.service';
import { RecoverFormComponent } from '../recover-form/recover-form.component';

@Component({
	selector: 'app-recover',
	standalone: true,
	imports: [
		SharedModule,
		RecoverFormComponent,
	],
	templateUrl: './recover.component.html',
	styleUrl: './recover.component.scss'
})
export class RecoverComponent {
	public loading: boolean = false;

	constructor(
		private nav: NavigationService,
	) { }

	public goToRegister = () => this.nav.goNewList();
	public goContact = () => this.nav.goContact();

}
